export default __webpack_public_path__ + "static/media/cashews.e8ebacf6.jpg";